
import React from 'react';
import Axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { useState } from 'react';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { ResetpwdAPIURL } from '../apiconstants/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingSpinner from '../helpers/loadingspinner';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import BeforeLoginHeader from '../commonlayouts/beforeloginheader';
import FooterLayout from '../commonlayouts/beforeloginfooter';
import Swal from 'sweetalert2';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const Resetpassword = () => {

  const search = useLocation().search;
  const token = new URLSearchParams(search).get("token");

  const formSchema = Yup.object().shape({
    password: Yup.string()
      .required('Password is mendatory')
      .matches(
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}$/,
        'one Capital,one Small Letter, and one number, characters should be between 6 to 15',
      ),

    confirmPwd: Yup.string()
      .required('Password is mendatory')
      .oneOf([Yup.ref('password')], 'Passwords does not match'),
  })
  const formOptions = { resolver: yupResolver(formSchema) }
  const { register, handleSubmit, reset, formState } = useForm(formOptions);
  const { errors } = formState
  const { isSubmitting } = formState;
  const apiUrl = ResetpwdAPIURL.APIURL;
  const [isLoading, setIsLoading] = useState(false)
const [showPassword, setShowPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);



  const onSubmit = (data, e) => {
    e.preventDefault();
    e.target.reset();
    setIsLoading(true)

    const fliterdata = { token: token, password: data.password, confirmPassword: data.confirmPwd };
    Axios.post(apiUrl, fliterdata)
      .then((result) => {
        setIsLoading(false)
        if (result.data.message === "Success") {
          
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Password reset successful, now you can login into Hire Me',
            showConfirmButton: false,
            timer: 5000
          })
          
          //toast.success('Data Saving', {autoClose:5000})

        }
        else if(result.data.message ==="Not Exist") {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Please provide a valid details.',
            showConfirmButton: false,
            timer: 5000
          })
          // toast.error('Issue with data format', {autoClose:5000})
        }
        else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Something gone Wrong',
            showConfirmButton: false,
            timer: 5000
          })
        }

     

      }).catch(
        function (error) {
          console.log("Error" + error)
          setIsLoading(false)
        })

    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });

  }
  return (

    <>
    <BeforeLoginHeader>
      {isLoading ? <center> <LoadingSpinner /> </center> :

        <div class="card shadow-sm p-5 border-0 login-card" >
          <form onSubmit={handleSubmit(onSubmit)} id="loginform">
            <h2 class="text-center mb-4 tq-wall"> No Worries! You can reset your password here.</h2>
                    <div class="mb-5 mt-3">

            <div className="mb-4 position-relative">
  <OverlayTrigger placement="bottom" overlay={(props) => (
    <Tooltip id="tooltip" {...props}>Password</Tooltip>
  )}>
    <input
      placeholder="Password"
      type={showPassword ? 'text' : 'password'}
      name="password"
      {...register("password")}
      className={`form-control shadow-sm ${errors.password ? 'is-invalid' : ''}`}
    />
  </OverlayTrigger>
  <span
    onClick={() => setShowPassword(!showPassword)}
    style={{
      position: 'absolute',
      top: '50%',
      right: '15px',
      transform: 'translateY(-50%)',
      cursor: 'pointer',
      zIndex: 2,
      color: '#6c757d'
    }}
  >
    {showPassword ?<FaEye  size={20}/> : <FaEyeSlash  size={20}/>}
  </span>
  <div className="invalid-feedback">{errors.password?.message}</div>
</div>

            <div className="mb-4 position-relative">
  <OverlayTrigger placement="bottom" overlay={(props) => (
    <Tooltip id="tooltip" {...props}>Confirm Password</Tooltip>
  )}>
    <input
      placeholder="Enter your Confirm password"
      type={showConfirmPassword ? 'text' : 'password'}
      name="confirmPwd"
      {...register("confirmPwd")}
      className={`form-control shadow-sm ${errors.confirmPwd ? 'is-invalid' : ''}`}
    />
  </OverlayTrigger>
  <span
    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
    style={{
      position: 'absolute',
      top: '50%',
      right: '15px',
      transform: 'translateY(-50%)',
      cursor: 'pointer',
      zIndex: 2,
      color: '#6c757d'
    }}
  >
    {showConfirmPassword ? <FaEye  size={20}/> : <FaEyeSlash  size={20}/>}
  </span>
  <div className="invalid-feedback">{errors.confirmPwd?.message}</div>
</div>

            </div>
            <div class="text-center mb-5">
              <button disabled={isSubmitting} class="btn btn-primary  login-button" style={{ width: "35%",fontWeight:"bold" }}>
                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
              Reset Password
              </button>
              <Link to="/Login"> <button  class="btn btn-primary " style={{backgroundColor:"#00a7ac",border:"none",borderRadius: 15,fontWeight:"bold"}}>
    
                 Cancel
                </button>
                </Link>
            </div>

          </form>
        </div>
      }
      </BeforeLoginHeader>
      <FooterLayout/>
    </>
  )
}


export default Resetpassword;